module.exports = "/images/NAP_portada.jpg?e30accd8f9043bc851056cc3e8523ae3";